import React, { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from 'react-router-dom';
const PriceStockDetails = () => {
  const [stockData, setStockData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [summary, setSummary] = useState({ heading: "", totalQuantity: 0, totalAmount: 0 });
   const [searchParams] = useSearchParams();
  const id = searchParams.get("id"); 

  console.log("id:",id);
  useEffect(() => {
    const fetchStockDetails = async () => {
      try {
               const response = await axios.get(
          `https://nissi-india.com/api/itemPrice_stockRpt/${id}`,
          {
            headers: {
              "x-finyearid": localStorage.getItem("finYearId") || "",
              "x-finyear": localStorage.getItem("finYear") || "",
              "x-branchid": localStorage.getItem("branchId") || "",
              "x-branch": localStorage.getItem("branchType") || "",
              "x-userid": localStorage.getItem("userId") || "",
            },
          }
        );
        setStockData(response.data.items || []);
        setSummary({
          heading: response.data.heading || "",
          totalQuantity: response.data.totalQuantity || 0,
          totalAmount: response.data.totalAmount || 0,
        });        console.log("response:", response.data);
      } catch (err) {
        setError("Failed to fetch stock details.");
      } finally {
        setLoading(false);
      }
    };

    fetchStockDetails();
  }, [id]);

  if (loading) return <p className="p-4">Loading...</p>;
  if (error) return <p className="p-4 text-red-600">{error}</p>;

    // "2026-09-12T00:00:00.000Z" -> "12/09/2026" (date part only, no timezone shift)
  const formatDate = (value) => {
    if (!value) return "";
    const [y, m, d] = String(value).slice(0, 10).split("-");
    return y && m && d ? `${d}/${m}/${y}` : String(value);
  };

  const money = (v) =>
    Number(v || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  return (
    <div className="p-4">
      <h2 className="text-lg font-bold mb-1">Item Price Details</h2>
      {summary.heading && <p className="mb-3 text-sm">{summary.heading}</p>}

      <table className="w-full border-collapse border border-gray-400 text-sm">
        <thead>
          <tr className="bg-gray-200">
            <th className="border border-gray-400 px-2 py-1">S.No</th>
            <th className="border border-gray-400 px-2 py-1">GRN No</th>
            <th className="border border-gray-400 px-2 py-1">Date</th>
            <th className="border border-gray-400 px-2 py-1">Branch</th>
            <th className="border border-gray-400 px-2 py-1">Supplier</th>
            <th className="border border-gray-400 px-2 py-1">UOM</th>
            <th className="border border-gray-400 px-2 py-1">GRN Qty</th>
            <th className="border border-gray-400 px-2 py-1">Accepted Qty</th>
            <th className="border border-gray-400 px-2 py-1">PO Price</th>
            <th className="border border-gray-400 px-2 py-1">Price incl. Tax/Duty</th>
            <th className="border border-gray-400 px-2 py-1">Total</th>
          </tr>
        </thead>
        <tbody>
          {stockData.length > 0 ? (
            <>
              {stockData.map((row, index) => (
                <tr key={row.fld_GRNDetid ?? index} className="hover:bg-gray-100">
                  <td className="border border-gray-400 px-2 py-1">{index + 1}</td>
                  <td className="border border-gray-400 px-2 py-1">{row.fld_grnno}</td>
                  <td className="border border-gray-400 px-2 py-1">{formatDate(row.fld_Date)}</td>
                  <td className="border border-gray-400 px-2 py-1">{row.fld_branchName}</td>
                  <td className="border border-gray-400 px-2 py-1">{row.fld_suppliername}</td>
                  <td className="border border-gray-400 px-2 py-1">{(row.fld_uomname || "").trim()}</td>
                  <td className="border border-gray-400 px-2 py-1 text-right">{Number(row.fld_GRNQty || 0).toFixed(3)}</td>
                  <td className="border border-gray-400 px-2 py-1 text-right">{Number(row.fld_acceptedQty || 0).toFixed(3)}</td>
                  <td className="border border-gray-400 px-2 py-1 text-right">{money(row.fld_poPrice)}</td>
                  <td className="border border-gray-400 px-2 py-1 text-right">{money(row.fld_atPrice)}</td>
                  <td className="border border-gray-400 px-2 py-1 text-right">{money(row.Total)}</td>
                </tr>
              ))}
              <tr className="bg-gray-100 font-semibold">
                <td colSpan="7" className="border border-gray-400 px-2 py-1 text-right">Total</td>
                <td className="border border-gray-400 px-2 py-1 text-right">{Number(summary.totalQuantity).toFixed(3)}</td>
                <td colSpan="2" className="border border-gray-400 px-2 py-1"></td>
                <td className="border border-gray-400 px-2 py-1 text-right">{money(summary.totalAmount)}</td>
              </tr>
            </>
          ) : (
            <tr>
              <td colSpan="11" className="text-center p-2">
                No records found
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default PriceStockDetails;
